import PropTypes from 'prop-types';
// @mui
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import Iconify from 'src/components/iconify';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import { ConfirmDialog } from 'src/components/custom-dialog';
//

// ----------------------------------------------------------------------

export default function UserTableRow({ row, selected, onEditRow, onSelectRow, onDeleteRow, projectId }) {
    const { name, title_code, title_category, base_wage, suppl_benefits, employer_taxes, workers_comp_insurance, misc_expanses, regular_time_rate
        , double_time_rate, over_time_rate
    } = row;
    console.log(row, '=======================')
    const confirm = useBoolean();

    const popover = usePopover();

    return (
        <>
            <TableRow hover selected={ selected }>
                <TableCell padding="checkbox">
                    <Checkbox checked={ selected } onClick={ onSelectRow } />
                </TableCell>


                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ title_code }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ name }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ title_category }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ base_wage }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ suppl_benefits }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ employer_taxes }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ workers_comp_insurance }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ misc_expanses }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ regular_time_rate }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ double_time_rate }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ over_time_rate }</TableCell>
                <TableCell align="right" sx={ { px: 1, whiteSpace: 'nowrap' } }>
                    <IconButton color={ popover.open ? 'inherit' : 'default' } onClick={ popover.onOpen }>
                        <Iconify icon="eva:more-vertical-fill" />
                    </IconButton>
                </TableCell>
            </TableRow>
            <CustomPopover
                open={ popover.open }
                onClose={ popover.onClose }
                arrow="right-top"
                sx={ { width: 140 } }
            >
                <MenuItem
                    onClick={ () => {
                        confirm.onTrue();
                        popover.onClose();
                    } }
                    sx={ { color: 'error.main' } }
                >
                    <Iconify icon="solar:trash-bin-trash-bold" />
                    Delete
                </MenuItem>

                <MenuItem
                    onClick={ () => {
                        onEditRow();
                        popover.onClose();
                    } }
                >
                    <Iconify icon="solar:pen-bold" />
                    Edit
                </MenuItem>
            </CustomPopover>
            <ConfirmDialog
                open={ confirm.value }
                onClose={ confirm.onFalse }
                title="Delete"
                content="Are you sure want to delete?"
                action={
                    <Button variant="contained" color="error" onClick={ onDeleteRow }>
                        Delete
                    </Button>
                }
            />
        </>
    );
}
UserTableRow.propTypes = {
    onDeleteRow: PropTypes.func,
    onEditRow: PropTypes.func,
    onSelectRow: PropTypes.func,
    row: PropTypes.object,
    selected: PropTypes.bool,
};